import { useContext } from "react";
import { CancellationModalContext } from "./CancellationModalProvider";

export const useCancellationModal = () => {
  const ctx = useContext(CancellationModalContext);
  if (ctx == null) {
    throw new Error(
      "useCancellationModal must be used within CancellationModalProvider"
    );
  }

  return ctx;
};
